<template>
    <div>
        <DTable
            :items="modelValue"
            :fields="fields"
            class="table-responsive"
        >
            <template
                v-for="(key, index) in getColumnData"
                #[key]="{item}"
                :key="index"
            >
                <td>
                    <span v-if="transformers[key] !== undefined">
                        {{ transformers[key](item[key]) }}
                    </span>
                    <span v-else>
                        {{ item[key] ?? '' }}
                    </span>
                    <p
                        v-if="errors[`${errorPrefix}.${item.index}.${key}`]"
                        class="error-msg"
                    >
                        {{ errors[`${errorPrefix}.${item.index}.${key}`] }}
                    </p>
                </td>
            </template>
            <template #actions="{item}">
                <td class="action-btn">
                    <DButton
                        mini
                        icon="pencil"
                        :disabled="isInLoadingState"
                        @click="editRow(item)"
                    />
                    <DButton
                        mini
                        color="danger"
                        icon="trash-can-outline"
                        :disabled="isInLoadingState"
                        @click="deleteRow(item)"
                    />
                </td>
            </template>
        </DTable>
        <p
            v-if="errors[errorPrefix]"
            class="error-msg"
        >
            {{ errors[errorPrefix] }}
        </p>
        <p>
            <DButton
                mini
                color="primary"
                icon="plus"
                :disabled="isInLoadingState"
                @click="addNewRow()"
            />
        </p>
        <DModal
            v-if="showModal"
            :show="showModal"
            is-confirm
            :title="modalTitle"
            :confirm-button-text="__('messages.done')"
            @close="closeModal"
            @confirm="setRecord"
        >
            <DCard padding>
                <slot
                    name="modalForm"
                    :item="selectedItem"
                />
            </DCard>
        </DModal>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import _ from 'lodash'

const props = defineProps({
    fields: {
        type: Array,
        default: () => { return [] }
    },
    modelValue: {
        type: Array,
        default: () => { return [] }
    },
    transformers: {
        type: Object,
        default: () => { return {} }
    },
    newRowData: {
        type: Object,
        default: () => { return {} }
    },
    modalTitleAdd: {
        type: String,
        default: () => { return '' }
    },
    modalTitleEdit: {
        type: String,
        default: () => { return '' }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    },
    errorPrefix: {
        type: String,
        default: () => { return '' }
    }
})

const emit = defineEmits(['update:modelValue'])

const showModal = ref(false)
const selectedItem = ref({})
const modalTitle = ref('')
const modalAction = ref('')

const getColumnData = computed(() => {
    const keys = []
    props.fields.forEach((data) => {
        if (data.key !== 'actions') {
            keys.push(data.key)
        }
    })

    return keys
})

function addNewRow () {
    selectedItem.value = props.newRowData
    modalTitle.value = props.modalTitleAdd
    modalAction.value = 'add'
    showModal.value = true
}

function editRow (item) {
    selectedItem.value = _.cloneDeep(item)
    modalTitle.value = props.modalTitleEdit
    modalAction.value = 'edit'
    showModal.value = true
}

function deleteRow (value) {
    const itemsData = _.cloneDeep(props.modelValue).filter(function (item) { return item.index !== value.index })

    emit('update:modelValue', itemsData)
}
function closeModal () {
    selectedItem.value = {}
    modalTitle.value = ''
    modalAction.value = ''
    showModal.value = false
}

function setRecord () {
    const item = selectedItem.value
    const itemsData = _.cloneDeep(props.modelValue)

    if (modalAction.value === 'add') {
        itemsData.push(item)
    } else {
        itemsData.forEach((data) => {
            if (data.index === item.index) {
                itemsData[data.index] = item
            }
        })
    }

    emit('update:modelValue', itemsData)

    closeModal()
}
</script>

<style scoped lang="scss">
.action-btn {
    display: flex;
    grid-gap: 5px;
}
.error-msg {
    margin: 0 0 2px 5px;
    font-size: 12px;
    color: var(--colorDanger);
}
</style>
